export type CanonicalFields = {
  session_id: string | null;
  store_id: string;
  tab_id?: string;
  from_state?: string;
  to_state?: string;
  trigger?: string;
  [k: string]: unknown;
};

/**
 * Emit a [receiving]-prefixed structured log line.  Uses console.log so the
 * browser-logs SDK's forwardConsoleLogs config captures it and forwards to
 * Datadog Logs.  Do not wrap in a DEV guard — Dirk's remote smoke traffic
 * must be visible.
 */
export function receivingLog(event: string, fields: CanonicalFields): void {
  console.log(`[receiving] ${event}`, fields);
}
